


























import { Component, Prop, Vue } from 'vue-property-decorator'
import pdf from 'vue-pdf'
const baseUrl = 'https://h5.ecom.mgtv.com/ac/file/supplier/'
@Component({
  components: {
    pdf,
  },
})
export default class PrintDialog extends Vue {
  @Prop(Array) pdfList!: any
  pdfSrc = ''
  numPages = null
  loadingIndex = 99
  timer: any = null

  // get finalList() {
  //   // 过滤掉电子合同
  //   return this.pdfList.filter((item: any) => !item.electronic)
  // }

  beforeDestroy() {
    clearTimeout(this.timer)
  }
  getNumPages() {
    const loadingTask = pdf.createLoadingTask(this.pdfSrc)
    loadingTask.promise
      .then((pdf: any) => {
        this.numPages = pdf.numPages
      })
      .catch((err: any) => {
        console.error('pdf 加载失败', err)
      })
  }
  printPdf(src: any, index: number) {
    this.loadingIndex = index
    this.pdfSrc = baseUrl + src

    this.getNumPages()
    this.timer = setTimeout(() => {
      this.loadingIndex = 99
      const vm: any = this.$refs.pdf
      vm[0].print()
    }, 4000)
  }
}
